// The platform's 4xx envelope is `{ errors: [{ code, message, detail }] }`;
// `detail` is the machine code a page branches on. Deliberately separate from
// messageFromError, which reads an error for display and always yields a
// string — a caller that switches on behaviour must not fall back to prose.
export function detailFromError(err: unknown): string | null {
  return (
    (err as { response?: { data?: { errors?: Array<{ detail?: string }> } } }).response?.data
      ?.errors?.[0]?.detail ?? null
  );
}
